import { usePageStore } from '@/store';
import { mapState as rootMapState } from 'pinia';
import {  mapActions, mapState } from '@/store/helpers';
import getUseStore from './_store';
import {
    SET_SHOW_SOLD_LISTING_PRICE,
    SET_SHOW_LISTING_PRICE,
    UPDATE_SEARCH_PARAMS
} from './_store/constants';
import { normal } from '../defaultSpacing';


import { mapAsyncData } from '../../plugins/asyncData';
import { asyncData } from './asyncData';
export default {
    i18next: {
        ns: ['md-snapshot-search', 'md-search-bar']
    },
    _getUseStore: getUseStore,
    asyncData: mapAsyncData(asyncData),
    mounted() {
        this.init();
    },
    data: function() {
        return {
            presetFilters: [],
            presetFiltersV2: {},
            marketTitle: '',
            listingTitle: '',
            showSearchBar: true,
            // buttonColor: '',
            // buttonTitle: '',
            ...normal
        };
    },
    watch: {
        // listingTitle() {
        //     this.setCustomRecentTitle();
        // },
        // buttonTitle() {
        //     this.setMoreBtn();
        // },
        // buttonColor() {
        //     this.setMoreBtn();
        // },
        currentLanguage() {
            this.clearCondition();
        }
    },
    computed: {
        ...rootMapState(usePageStore, {
            "currentLanguage": store => store.currentLanguage,
            "page": store => store.page || {}
        }),
        ...mapState({
            'keywords': store => store.keywords
        }),
        isMobile() {
            return this.platform.isMobile;
        },
        paddingTop() {
            return (
                (this.isMobile ? this.mobileTopSpacing : this.topSpacing) + 'px'
            );
        },
        marginBottom() {
            return (
                (this.isMobile ? this.mobileBtmSpacing : this.btmSpacing) + 'px'
            );
        },
        dataToSearchBar() {
            return {
                presetFilters: this.presetFilters,
                presetFiltersV2: this.presetFiltersV2
            };
        },
        customListingTitle() {
            return this.listingTitle || this.cmpDefaultListingTitle || 'Recent Listings'
        },
        snapshotMarketTitle() {
            return this.marketTitle || this.$t('md-snapshot-search.marketTitle')
        },
        featureAreaMarketRefineLink({ page, keywords }) {
            if (page.pageKey === 'featured-area-market') {
                let condition = {}, [keyword] = keywords || [], query = '';
                if (keyword) {
                    if (page.searchCenter) {
                        condition.location = {
                            [keyword.keywordType]: [keyword.keyword]
                        }
                        query = 'condition=' + JSON.stringify(condition)
                    } else {
                        query = `key=${keyword.keyword}&&keywordType=${keyword.keywordType}`
                    }
                    return '/snapshot?' + query
                }
            }
            return false
        }
        // snapshotButtonTitle(){
        //     return this.buttonTitle || this.$t('md-snapshot-search.buttonTitle')
        // }
    },
    methods: {
        ...mapActions({
            "setShowSoldPrice": SET_SHOW_SOLD_LISTING_PRICE,
            "setShowListingPrice": SET_SHOW_LISTING_PRICE,
            "updateSearchParams": UPDATE_SEARCH_PARAMS
        }),
        clearCondition() {
            this.updateSearchParams({});
        },
        conditionChange(params) {
            let { condition } = params;
            delete condition.listingSource;
            this.updateSearchParams(condition);
        },
        //  initialization function 
        async init() {
            this.setGlobalData(); //  Set related global data 
            // this.setMoreBtn();
            // this.setCustomRecentTitle();
            // await this.handlePreset(); //  wait first  md-search initialization 
            // this.changeSearchInit({ data: true });
        },
        //  set up more button style, etc. 
        // setMoreBtn() {
        //     if (this.buttonTitle) {
        //         this.setMoreBtnTitle({
        //             data: this.buttonTitle
        //         });
        //     }
        //     this.setMoreBtnStyle({
        //         data: { backgroundColor: this.buttonColor || '' }
        //     });
        // },
        //  set up  recent listing title
        // setCustomRecentTitle() {
        //     this.setListingTitle({
        //         data: this.listingTitle || this.cmpDefaultListingTitle
        //     });
        // },
        //  Set related global data 
        setGlobalData() {
            const house = this.page.house;
            if (house) {
                this.setShowSoldPrice({ data: house.showSoldPrice });
                this.setShowListingPrice({ data: house.showListingPrice });
            }
        }
    },
    provide() {
        return {
            featureAreaMarketRefineLink: () => this.featureAreaMarketRefineLink
        }
    }
};
